<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('blackListContact') }}</h3>
      <div class="tile-body">
        <div class="c-config-content">
          <div v-if="firstLoading">
            <skeleton-loading>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
              </row>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
              </row>
            </skeleton-loading>
          </div>
          <div v-else>
            <div class="c-template-table table-responsive c-role-table">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{ $t('info') }}</th>
                  <th>{{ $t('desc') }}</th>
                  <th class="text-right">
                    <black-list-contact-import class="mr-1 mb-1"></black-list-contact-import>
                    <black-list-contact-export class="mr-1 mb-1" v-if="itemCount" :filter=filterFormModel :totalCount="itemCount"></black-list-contact-export>
                    <br>
                    <button class="btn btn-success btn-sm mr-1 mb-1" @click="create" v-if="$store.state.user.permissions.includes('blackListContactSetup')">
                      <i class="icon12-add-white icon-left"></i>{{ $t('create') }}
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody v-if="listLoading" class="text-center text-primary">
                <tr>
                  <th colspan="3">
                    <b-spinner></b-spinner>
                  </th>
                </tr>
                </tbody>
                <tbody v-if="!listLoading && !itemCount" class="text-center">
                <tr>
                  <th colspan="3">
                    {{ $t('noBlackListContactFound') }}
                  </th>
                </tr>
                </tbody>
                <tbody v-if="!listLoading && itemCount">
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <p>
                      <span>{{ $t(item.type) }}: </span> <b>{{ item.contact }}</b>
                    </p>
                    <p>
                      <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                    </p>
                    <p v-if="item.updateTime">
                      <span>{{ $t('updateTime') }}: </span> <b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                    </p>
                  </td>
                  <td>
                    <p>
                      <label v-if="!item.direction || item.direction === 'all'" class="badge badge-secondary">{{$t('twoWayBlocked')}}</label>
                      <label v-else-if="item.direction === 'in'" class="badge badge-secondary">{{$t('inboundBlocked')}}</label>
                      <label v-else class="badge badge-secondary">{{$t('outboundBlocked')}}</label>
                    </p>
                    <span v-if="item.desc">{{ item.desc}}</span>
                  </td>
                  <td class="text-right">
                    <button @click="del(item._id)" :disabled="delLoading" class="mr-1 btn btn-outline-gray btn-sm is-border-1"
                            type="button" v-if="$store.state.user.permissions.includes('blackListContactSetup')">
                      <b-spinner v-if="delLoading" small></b-spinner>
                      <i v-else class="icon12-delete-primary"></i>
                    </button>
                    <button @click="update(item._id)" :disabled="updateLoading" class="btn btn-outline-gray btn-sm is-border-1"
                            type="button" v-if="$store.state.user.permissions.includes('blackListContactSetup')">
                      <b-spinner v-if="updateLoading" small></b-spinner>
                      <i v-else class="icon12-edit-primary"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
              <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load">
              </b-pagination>
            </div>
          </div>
          <b-modal v-model="showForm" :title="formTitle + $t('blackListContactFormTitle')" @ok="save" no-close-on-backdrop
                   no-enforce-focus>
            <div class="row">
              <div class="col-md">
                <form-select :label="$t('type')" :model="formModel" attribute="type" :errors="formErrors" :options="[
                    {value: 'phone', text: $t('phone')},
                    {value: 'email', text: $t('email')},
                    {value: 'facebook', text: $t('facebook')},
                ]"></form-select>
                <form-select :label="$t('blockDirection')" :model="formModel" attribute="direction" :errors="formErrors" :options="[
                    {value: 'all', text: $t('twoWayBlocked')},
                    {value: 'in', text: $t('inboundBlocked')},
                    {value: 'out', text: $t('outboundBlocked')},
                ]"></form-select>
                <form-input :label="$t('contact')" :model="formModel" attribute="contact" :errors="formErrors" :placeholder="$t('blackListContactPlaceholder')"></form-input>
                <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors" :placeholder="$t('descPlaceholder')"></form-input>
              </div>
            </div>
            <template v-slot:modal-footer>
              <b-button variant="secondary" class="float-right" @click="showForm = false">{{$t('cancel')}}
              </b-button>
              <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                <b-spinner v-if="saveLoading" small></b-spinner>
                {{$t('save')}}
              </b-button>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import List from "@/mixins/List";
import CRUD from '../../../../mixins/CRUD';
import BlackListContactImport from "./BlackListContactImport";
import BlackListContactExport from './BlackListContactExport.vue';

export default {
  mixins: [List, CRUD],
  components: {BlackListContactImport, BlackListContactExport},
  name: "BlackListContact",
  data: function () {
    return {
      service: '/black-list-contact',
      defaultFormModel: {
        type: 'phone',
        direction: 'all'
      }
    }
  },
  mounted() {
    this.$bus.$on('reloadBlackListContact', this.load);
  },
  beforeDestroy: function () {
    this.$bus.$off('reloadBlackListContact');
  },
}
</script>